//Login page
export const POST_LOGIN_REQUEST = "POST_LOGIN_REQUEST";
export const POST_LOGIN_REQUEST_SUCCESS = "POST_LOGIN_REQUEST_SUCCESS";
export const POST_LOGIN_REQUEST_FAIL = "POST_LOGIN_REQUEST_FAIL";
export const PASSWORD_IS_EXPIRED = "PASSWORD_IS_EXPIRED";

// quota
export const GET_QUOTA_REQUEST = "GET_QUOTA_REQUEST";
export const GET_QUOTA_SUCCESS = "GET_QUOTA_SUCCESS";
export const GET_QUOTA_ERROR = "GET_QUOTA_ERROR";

export const OPEN_QUOTA_MODAL = "OPEN_QUOTA_MODAL";
export const CLOSE_QUOTA_MODAL = "CLOSE_QUOTA_MODAL";

// notification
export const GET_ALL_NOTIFICATION_REQUEST = "GET_ALL_NOTIFICATION_REQUEST";
export const GET_ALL_NOTIFICATION_SUCCESS = "GET_ALL_NOTIFICATION_SUCCESS";
export const GET_ALL_NOTIFICATION_FAIL = "GET_ALL_NOTIFICATION_FAIL";
export const GET_NOTIFICATION_NUMBER_SUCCESS =
  "GET_NOTIFICATION_NUMBER_SUCCESS";
export const GET_MORE_NOTIFICATION_REQUEST = "GET_MORE_NOTIFICATION_REQUEST";
export const GET_MORE_NOTIFICATION_SUCCESS = "GET_MORE_NOTIFICATION_SUCCESS";
export const GET_MORE_NOTIFICATION_FAIL = "GET_MORE_NOTIFICATION_FAIL";
export const GET_POLLING_NOTIFICATION_SUCCESS =
  "GET_POLLING_NOTIFICATION_SUCCESS";
export const MARK_AS_READ = "MARK_AS_READ";

//dashboard payroll
export const GET_ALL_PAYROLL_REQUEST = "GET_ALL_PAYROLL_REQUEST";
export const GET_ALL_PAYROLL_SUCCESS = "GET_ALL_PAYROLL_SUCCESS";
export const GET_ALL_PAYROLL_FAIL = "GET_ALL_PAYROLL_FAIL";
export const GET_PAYROLL_DETAIL_REQUEST = "GET_PAYROLL_DETAIL_REQUEST";
export const GET_PAYROLL_DETAIL_SUCCESS = "GET_PAYROLL_DETAIL_SUCCESS";
export const GET_PAYROLL_DETAIL_FAIL = "GET_PAYROLL_DETAIL_FAIL";

//User Shift Type
export const GET_USER_SHIFT_TYPES_REQUEST = "GET_USER_SHIFT_TYPES_REQUEST";
export const GET_USER_SHIFT_TYPES_SUCCESS = "GET_USER_SHIFT_TYPES_SUCCESS";
export const GET_USER_SHIFT_TYPES_FAIL = "GET_USER_SHIFT_TYPES_FAIL";

//check time
export const GET_CHECK_TIME_REQUEST = "GET_CHECK_TIME_REQUEST";
export const GET_CHECK_TIME_REQUEST_SUCCESS = "GET_CHECK_TIME_REQUEST_SUCCESS";
export const GET_CHECK_TIME_REQUEST_FAIL = "GET_CHECK_TIME_REQUEST_FAIL";

// TODO: remove it if API /get-basic-profile return qrcode
export const GET_USER_QR_CODE = "GET_USER_QR_CODE";

//get user
export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_REQUEST_SUCCESS = "GET_USERS_REQUEST_SUCCESS";
export const GET_USERS_REQUEST_FAIL = "GET_USERS_REQUEST_FAIL";

//get user by ID
export const GET_USERS_BY_ID_REQUEST = "GET_USERS_BY_ID_REQUEST";
export const GET_USERS_BY_ID_REQUEST_SUCCESS =
  "GET_USERS_BY_ID_REQUEST_SUCCESS";
export const GET_USERS_BY_ID_REQUEST_FAIL = "GET_USERS_BY_ID_REQUEST_FAIL";

//update user
export const UPDATE_USERS_REQUEST = "UPDATE_USERS_REQUEST";
export const UPDATE_USERS_REQUEST_SUCCESS = "UPDATE_USERS_REQUEST_SUCCESS";
export const UPDATE_USERS_REQUEST_FAIL = "UPDATE_USERS_REQUEST_FAIL";

//update emergency contact
export const UPDATE_EMERGENCY_CONTACT = "UPDATE_EMERGENCY_CONTACT";
export const UPDATE_EMERGENCY_CONTACT_SUCCESS =
  "UPDATE_EMERGENCY_CONTACT_SUCCESS";
export const UPDATE_EMERGENCY_CONTACT_FAIL = "UPDATE_EMERGENCY_CONTACT_FAIL";

//add user
export const ADD_USERS_REQUEST = "ADD_USERS_REQUEST";
export const ADD_USERS_REQUEST_SUCCESS = "ADD_USERS_REQUEST_SUCCESS";
export const ADD_USERS_REQUEST_FAIL = "ADD_USERS_REQUEST_FAIL";

//del user
export const DEL_USERS_REQUEST = "DEL_USERS_REQUEST";
export const DEL_USERS_REQUEST_SUCCESS = "DEL_USERS_REQUEST_SUCCESS";
export const DEL_USERS_REQUEST_FAIL = "DEL_USERS_REQUEST_FAIL";

//get user shift time
export const GET_USER_SHIFT_TIME = "GET_USER_SHIFT_TIME";
export const GET_USER_SHIFT_TIME_SUCCESS = "GET_USER_SHIFT_TIME_SUCCESS";
export const GET_USER_SHIFT_TIME_FAIL = "GET_USER_SHIFT_TIME_FAIL";

//get user shift time
export const GET_USER_SHIFT_OVERTIME = "GET_USER_SHIFT_OVERTIME";
export const GET_USER_SHIFT_OVERTIME_SUCCESS =
  "GET_USER_SHIFT_OVERTIME_SUCCESS";
export const GET_USER_SHIFT_OVERTIME_FAIL = "GET_USER_SHIFT_OVERTIME_FAIL";

//get user checktime
export const GET_USERS_CHECKTIME_REQUEST = "GET_USERS_CHECKTIME";
export const GET_USERS_CHECKTIME_SUCCESS = "GET_USERS_CHECKTIME_SUCCESS";
export const GET_USERS_CHECKTIME_FAIL = "GET_USERS_CHECKTIME_FAIL";

//change user password
export const CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD";
export const CHANGE_USER_PASSWORD_SUCCESS = "CHANGE_USER_PASSWORD_SUCCESS";
export const CHANGE_USER_PASSWORD_FAIL = "CHANGE_USER_PASSWORD_FAIL";

//change user password by ID
export const CHANGE_USER_PASSWORD_BY_ID = "CHANGE_USER_PASSWORD_BY_ID";
export const CHANGE_USER_PASSWORD_BY_ID_SUCCESS =
  "CHANGE_USER_PASSWORD_BY_ID_SUCCESS";
export const CHANGE_USER_PASSWORD_BY_ID_FAIL =
  "CHANGE_USER_PASSWORD_BY_ID_FAIL";

//Shift page
//get list shift type
export const GET_SHIFT_TYPES = "GET_SHIFT_TYPES";
export const GET_SHIFT_TYPES_SUCCESS = "GET_SHIFT_TYPES_SUCCESS";
export const GET_SHIFT_TYPES_FAIL = "GET_SHIFT_TYPES_FAIL";

//get list shift sessions
export const GET_SHIFT_SESIONS = "GET_SHIFT_SESIONS";
export const GET_SHIFT_SESIONS_SUCCESS = "GET_SHIFT_SESIONS_SUCCESS";
export const GET_SHIFT_SESIONS_FAIL = "GET_SHIFT_SESIONS_FAIL";

//update shift sessions
export const UPDATE_SHIFT_SESSIONS = "UPDATE_SHIFT_SESSIONS";
export const UPDATE_SHIFT_SESSIONS_SUCCESS = "UPDATE_SHIFT_SESSIONS_SUCCESS";
export const UPDATE_SHIFT_SESSIONS_FAIL = "UPDATE_SHIFT_SESSIONS_FAIL";

//get 1 shift type
export const GET_SHIFT_TYPE_BY_ID = "GET_SHIFT_TYPE_BY_ID";
export const GET_SHIFT_TYPE_BY_ID_SUCCESS = "GET_SHIFT_TYPE_BY_ID_SUCCESS";
export const GET_SHIFT_TYPE_BY_ID_FAIL = "GET_SHIFT_TYPE_BY_ID_FAIL";

//add shift type
export const ADD_NEW_SHIFT = "ADD_NEW_SHIFT";
export const ADD_NEW_SHIFT_SUCCESS = "ADD_NEW_SHIFT_SUCCESS";
export const ADD_NEW_SHIFT_FAIL = "ADD_NEW_SHIFT_FAIL";

//delete shift type
export const DELETE_SHIFT_TYPE = "DELETE_SHIFT_TYPE";
export const DELETE_SHIFT_TYPE_SUCCESS = "DELETE_SHIFT_TYPE_SUCCESS";
export const DELETE_SHIFT_TYPE_FAIL = "DELETE_SHIFT_TYPE_FAIL";

//edit shift type
export const EDIT_SHIFT_TYPE = "EDIT_SHIFT_TYPE";
export const EDIT_SHIFT_TYPE_SUCCESS = "EDIT_SHIFT_TYPE_SUCCESS";
export const EDIT_SHIFT_TYPE_FAIL = "EDIT_SHIFT_TYPE_FAIL";

// user shift type
export const POST_USER_SHIFT_TYPES_SUCCESS = "POST_USER_SHIFT_TYPES_SUCCESS";
export const POST_USER_SHIFT_TYPES = "POST_USER_SHIFT_TYPES";
export const POST_USER_SHIFT_TYPES_FAIL = "POST_USER_SHIFT_TYPES_FAIL";

//delete shift type
export const DELETE_USER_SHIFT_TYPES_SUCCESS =
  "DELETE_USER_SHIFT_TYPES_SUCCESS";
export const DELETE_USER_SHIFT_TYPES = "DELETE_USER_SHIFT_TYPES";
export const DELETE_USER_SHIFT_TYPES_FAIL = "DELETE_USER_SHIFT_TYPES_FAIL";

//leave shift type
export const LEAVE_USER_SHIFT_TYPES_SUCCESS = "LEAVE_USER_SHIFT_TYPES_SUCCESS";
export const LEAVE_USER_SHIFT_TYPES = "LEAVE_USER_SHIFT_TYPES";
export const LEAVE_USER_SHIFT_TYPES_FAIL = "LEAVE_USER_SHIFT_TYPES_FAIL";

//GET_KEY_TO_CHECK_TIME_REQUEST_SUCCESS
export const GET_KEY_TO_CHECK_TIME_REQUEST_SUCCESS =
  "GET_KEY_TO_CHECK_TIME_REQUEST_SUCCESS";
export const GET_KEY_TO_CHECK_TIME_REQUEST = "GET_KEY_TO_CHECK_TIME_REQUEST";
export const GET_KEY_TO_CHECK_TIME_REQUEST_FAIL =
  "GET_KEY_TO_CHECK_TIME_REQUEST_FAIL";

//get user infomation
export const GET_BASIC_PROFILE_REQUEST = "GET_BASIC_PROFILE_REQUEST";
export const GET_BASIC_PROFILE_FAIL = "GET_BASIC_PROFILE_FAIL";
export const GET_BASIC_PROFILE_SUCCESS = "GET_BASIC_PROFILE_SUCCESS";

//get emergency contact
export const GET_EMERGENCY_CONTACT_REQUEST = "GET_EMERGENCY_CONTACT_REQUEST";
export const GET_EMERGENCY_CONTACT_REQUEST_FAIL =
  "GET_EMERGENCY_CONTACT_REQUEST_FAIL";
export const GET_EMERGENCY_CONTACT_REQUEST_SUCCESS =
  "GET_EMERGENCY_CONTACT_REQUEST_SUCCESS";

//get user shift type by token
export const GET_USER_SHIFT_TYPES_BY_TOKEN = "GET_USER_SHIFT_TYPES_BY_TOKEN";
export const GET_USER_SHIFT_TYPES_BY_TOKEN_SUCCESS =
  "GET_USER_SHIFT_TYPES_BY_TOKEN_SUCCESS";
//get status
export const GET_STATUS_REQUEST = "GET_STATUS_REQUEST";
export const GET_STATUS_SUCCESS = "GET_STATUS_SUCCESS";
export const GET_STATUS_FAIL = "GET_STATUS_FAIL";
//get all status
export const GET_ALL_STATUS = "GET_ALL_STATUS";
export const GET_ALL_STATUS_SUCCESS = "GET_ALL_STATUS_SUCCESS";
export const GET_ALL_STATUS_FAIL = "GET_ALL_STATUS_FAIL";

//get status by id
export const GET_STATUS_BY_ID = "GET_STATUS_BY_ID";
export const GET_STATUS_BY_ID_SUCCESS = "GET_STATUS_BY_ID_SUCCESS";
export const GET_STATUS_BY_ID_FAIL = "GET_STATUS_BY_ID_FAIL";

//add status
export const POST_STATUS = "POST_STATUS";
export const POST_STATUS_SUCCESS = "POST_STATUS_SUCCESS";
export const POST_STATUS_FAIL = "POST_STATUS_FAIL";

//delete status
export const DELETE_STATUS = "DELETE_STATUS";
export const DELETE_STATUS_SUCCESS = "DELETE_STATUS_SUCCESS";
export const DELETE_STATUS_FAIL = "DELETE_STATUS_FAIL";

//edit status
export const EDIT_STATUS = "EDIT_STATUS";
export const EDIT_STATUS_SUCCESS = "EDIT_STATUS_SUCCESS";
export const EDIT_STATUS_FAIL = "EDIT_STATUS_FAIL";

//get branch
export const GET_BRANCH_REQUEST = "GET_BRANCH_REQUEST";
export const GET_BRANCH_SUCCESS = "GET_BRANCH_SUCCESS";
export const GET_BRANCH_FAIL = "GET_BRANCH_FAIL";

//post new branch
export const POST_BRANCH = "POST_BRANCH";
export const POST_BRANCH_SUCCESS = "POST_BRANCH_SUCCESS";
export const POST_BRANCH_FAIL = "POST_BRANCH_FAIL";

//delete branch
export const DELETE_BRANCH = "DELETE_BRANCH";
export const DELETE_BRANCH_SUCCESS = "DELETE_BRANCH_SUCCESS";
export const DELETE_BRANCH_FAIL = "DELETE_BRANCH_FAIL";

//update branch
export const UPDATE_BRANCH = "UPDATE_BRANCH";
export const UPDATE_BRANCH_SUCCESS = "UPDATE_BRANCH_SUCCESS";
export const UPDATE_BRANCH_FAIL = "UPDATE_BRANCH_FAIL";

//get authorities
export const GET_AUTHORITIES_REQUEST = "GET_AUTHORITIES_REQUEST";
export const GET_AUTHORITIES_SUCCESS = "GET_AUTHORITIES_SUCCESS";
export const GET_AUTHORITIES_FAIL = "GET_AUTHORITIES_FAIL";

//get user of all branches
export const GET_USER_ALL_BRANCHES = "GET_USER_ALL_BRANCHES";
export const GET_USER_ALL_BRANCHES_SUCCESS = "GET_USER_ALL_BRANCHES_SUCCESS";
export const GET_USER_ALL_BRANCHES_FAIL = "GET_USER_ALL_BRANCHES_FAIL";

//add user to branch
export const POST_USER_BRANCH = "POST_USER_BRANCH";
export const POST_USER_BRANCH_SUCCESS = "POST_USER_BRANCH_SUCCESS";
export const POST_USER_BRANCH_FAIL = "POST_USER_BRANCH_FAIL";

//remove user in branch
export const REMOVE_USER_BRANCH = "REMOVE_USER_BRANCH";
export const REMOVE_USER_BRANCH_SUCCESS = "REMOVE_USER_BRANCH_SUCCESS";
export const REMOVE_USER_BRANCH_FAIL = "REMOVE_USER_BRANCH_FAIL";

//get all shifts
export const GET_ALL_SHIFTS = "GET_ALL_SHIFTS";
export const GET_ALL_SHIFTS_SUCCESS = "GET_ALL_SHIFTS_SUCCESS";
export const GET_ALL_SHIFTS_FAIL = "GET_ALL_SHIFTS_FAIL";

export const GET_SHIFT = "GET_ALL_SHIFT";
export const GET_SHIFT_SUCCESS = "GET_SHIFT_SUCCESS";
export const GET_SHIFT_FAIL = "GET_SHIFT_FAIL";

// get all shifts overtime
export const GET_ALL_SHIFTS_OVERTIME = "GET_ALL_SHIFTS_OVERTIME";
export const GET_ALL_SHIFTS_OVERTIME_SUCCESS =
  "GET_ALL_SHIFTS_OVERTIME_SUCCESS";
export const GET_ALL_SHIFTS_OVERTIME_FAIL = "GET_ALL_SHIFTS_OVERTIME_FAIL";

// request Export CSV
export const EXPORT_CSV_REQUEST = "EXPORT_CSV_REQUEST";
export const EXPORT_CSV_SUCCESS = "EXPORT_CSV_SUCCESS";
export const EXPORT_CSV_FAIL = "EXPORT_CSV_FAIL";

//update resident card
export const UPDATE_RESIDENT_CARD = "UPDATE_RESIDENT_CARD";
export const UPDATE_RESIDENT_CARD_SUCCESS = "UPDATE_RESIDENT_CARD_SUCCESS";
export const UPDATE_RESIDENT_CARD_FAIL = "UPDATE_RESIDENT_CARD_FAIL";

//request get generate
export const GET_GENERATE_REQUEST = "GET_GENERATE_REQUEST";
export const GET_GENERATE_SUCCESS = "GET_GENERATE_SUCCESS";
export const GET_GENERATE_FAIL = "GET_GENERATE_FAIL";

///change branch
export const CHANGE_BRANCH_SUCCESS = "CHANGE_BRANCH_SUCCESS";

//get user's shift today
export const GET_TODAY_USER_SHIFT_TYPES = "GET_TODAY_USER_SHIFT_TYPES";
export const GET_TODAY_USER_SHIFT_TYPES_SUCCESS =
  "GET_TODAY_USER_SHIFT_TYPES_SUCCESS";
export const GET_TODAY_USER_SHIFT_TYPES_FAIL =
  "GET_TODAY_USER_SHIFT_TYPES_FAIL";

//get organization
export const GET_ALL_ORGANIZATION = "GET_ALL_ORGANIZATION";
export const GET_ALL_ORGANIZATION_SUCCESS = "GET_ALL_ORGANIZATION_SUCCESS";
export const GET_ALL_ORGANIZATION_FAIL = "GET_ALL_ORGANIZATION_FAIL";

//post organization
export const POST_NEW_ORGANIZATION = "POST_NEW_ORGANIZATION";
export const POST_NEW_ORGANIZATION_SUCCESS = "POST_NEW_ORGANIZATION_SUCCESS";
export const POST_NEW_ORGANIZATION_FAIL = "POST_NEW_ORGANIZATION_FAIL";

//delete organization
export const DELETE_ORGANIZATION = "DELETE_ORGANIZATION";
export const DELETE_ORGANIZATION_SUCCESS = "DELETE_ORGANIZATION_SUCCESS";
export const DELETE_ORGANIZATION_FAIL = "DELETE_ORGANIZATION_FAIL";

//get holiday
export const GET_ALL_HOLIDAY = "GET_ALL_HOLIDAY";
export const GET_ALL_HOLIDAY_SUCCESS = "GET_ALL_HOLIDAY_SUCCESS";
export const GET_ALL_HOLIDAY_FAIL = "GET_ALL_HOLIDAY_FAIL";

/** START FACE ACTION **/
//GET FACE ACTION
export const GET_FACE_USER_BY_ID = "GET_FACE_USER_BY_ID";
export const GET_FACE_USER_BY_ID_SUCCESS = "GET_FACE_USER_BY_ID_SUCCESS";
export const GET_FACE_USER_BY_ID_FAIL = "GET_FACE_USER_BY_ID_FAIL";

//UPLOAD FACE ACTION
export const UPLOAD_USER_FACE = "UPLOAD_USER_FACE";
export const UPLOAD_USER_FACE_SUCCESS = "UPLOAD_USER_FACED_SUCCESS";
export const UPLOAD_USER_FACE_FAIL = "UPLOAD_USER_FACE_FAIL";

//DELETE FACE
export const DELETE_USER_FACE = "DELETE_USER_FACE";
export const DELETE_USER_FACE_SUCCESS = "DELETE_USER_FACE_SUCCESS";
export const DELETE_USER_FACE_FAIL = "DELETE_USER_FACE_FAIL";

export const SHOW_CROP_MODAL = "SHOW_CROP_MODAL";
export const HIDE_CROP_MODAL = "HIDE_CROP_MODAL";

/**------------------------START LOCK USER---------------------------------------------**/
export const POST_USER_LOCK_BY_ID_REQUEST = "POST_USER_LOCK_BY_ID_REQUEST";
export const POST_USER_LOCK_BY_ID_REQUEST_SUCCESS =
  "POST_USER_LOCK_BY_ID_REQUEST_SUCCESS";
export const POST_USER_LOCK_BY_ID_REQUEST_FAIL =
  "POST_USER_LOCK_BY_ID_REQUEST_FAIL";
/**------------------------END LOCK USER---------------------------------------------**/

//get total user working analysis
export const GET_TOTAL_USER_WORKING = "GET_TOTAL_USER_WORKING";
export const GET_TOTAL_USER_WORKING_SUCCESS = "GET_TOTAL_USER_WORKING_SUCCESS";
export const GET_TOTAL_USER_WORKING_FAIL = "GET_TOTAL_USER_WORKING_FAIL";

//get current user working analysis
export const GET_CURRENT_USER_WORKING = "GET_CURRENT_USER_WORKING";
export const GET_CURRENT_USER_WORKING_SUCCESS =
  "GET_CURRENT_USER_WORKING_SUCCESS";
export const GET_CURRENT_USER_WORKING_FAIL = "GET_CURRENT_USER_WORKING_FAIL";

//get working chart
export const GET_WORKING_CHART = "GET_WORKING_CHART";
export const GET_WORKING_CHART_SUCCESS = "GET_WORKING_CHART_SUCCESS";
export const GET_WORKING_CHART_FAIL = "GET_WORKING_CHART_FAIL";

//get user analysis detail
export const GET_USER_ANALYSIS_DETAIL = "GET_USER_ANALYSIS_DETAIL";
export const GET_USER_ANALYSIS_DETAIL_SUCCESS =
  "GET_USER_ANALYSIS_DETAIL_SUCCESS";
export const GET_USER_ANALYSIS_DETAIL_FAIL = "GET_USER_ANALYSIS_DETAIL_FAIL";

//LOGOUT
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_FAIL = "USER_LOGOUT_FAIL";

//get user working days
export const GET_USER_WORKING_DAYS = "GET_USER_WORKING_DAYS";
export const GET_USER_WORKING_DAYS_SUCCESS = "GET_USER_WORKING_DAYS_SUCCESS";
export const GET_USER_WORKING_DAYS_FAIL = "GET_USER_WORKING_DAYS_FAIL";

//get user latency
export const GET_USER_LATENCY = "GET_USER_LATENCY";
export const GET_USER_LATENCY_SUCCESS = "GET_USER_LATENCY_SUCCESS";
export const GET_USER_LATENCY_FAIL = "GET_USER_LATENCY_FAIL";

//get user reason
export const GET_USER_REASON = "GET_USER_REASON";
export const GET_USER_REASON_SUCCESS = "GET_USER_REASON_SUCCESS";
export const GET_USER_REASON_FAIL = "GET_USER_REASON_FAIL";

//get user location analysis
export const GET_USER_LOCATION_ANALYSIS =
  "GET_USEGET_USER_LOCATION_ANALYSISR_REASON";
export const GET_USER_LOCATION_ANALYSIS_SUCCESS =
  "GET_USER_LOCATION_ANALYSIS_SUCCESS";
export const GET_USER_LOCATION_ANALYSIS_FAIL =
  "GET_USER_LOCATION_ANALYSIS_FAIL";

//get user
export const GET_TEAMS_REQUEST = "GET_TEAMS_REQUEST";
export const GET_TEAMS_REQUEST_SUCCESS = "GET_TEAMS_REQUEST_SUCCESS";
export const GET_TEAMS_REQUEST_FAIL = "GET_TEAMS_REQUEST_FAIL";

//check organization
export const CHECK_ORGANIZATION_REQUEST = "CHECK_ORGANIZATION_REQUEST";
export const CHECK_ORGANIZATION_REQUEST_SUCCESS =
  "CHECK_ORGANIZATION_REQUEST_SUCCESS";
export const CHECK_ORGANIZATION_REQUEST_FAIL =
  "CHECK_ORGANIZATION_REQUEST_FAIL";

//get job type
export const GET_JOB_TYPE = "GET_JOB_TYPE";
export const GET_JOB_TYPE_SUCCESS = "GET_JOB_TYPE_SUCCESS";
export const GET_JOB_TYPE_FAIL = "GET_JOB_TYPE_FAIL";

//get all job type
export const GET_ALL_JOB_TYPE = "GET_ALL_JOB_TYPE";
export const GET_ALL_JOB_TYPE_SUCCESS = "GET_ALL_JOB_TYPE_SUCCESS";
export const GET_ALL_JOB_TYPE_FAIL = "GET_ALL_JOB_TYPE_FAIL";

//get job type by id
export const GET_JOB_TYPE_BY_ID_REQUEST = "GET_JOB_TYPE_BY_ID_REQUEST";
export const GET_JOB_TYPE_BY_ID_REQUEST_SUCCESS =
  "GET_JOB_TYPE_BY_ID_REQUEST_SUCCESS";
export const GET_JOB_TYPE_BY_ID_REQUEST_FAIL =
  "GET_JOB_TYPE_BY_ID_REQUEST_FAIL";

//add job type
export const ADD_JOB_TYPE_REQUEST = "ADD_JOB_TYPE_REQUEST";
export const ADD_JOB_TYPE_REQUEST_SUCCESS = "ADD_JOB_TYPE_REQUEST_SUCCESS";
export const ADD_JOB_TYPE_REQUEST_FAIL = "ADD_JOB_TYPE_REQUEST_FAIL";

//update job type
export const UPDATE_JOB_TYPE_REQUEST = "UPDATE_JOB_TYPE_REQUEST";
export const UPDATE_JOB_TYPE_REQUEST_SUCCESS =
  "UPDATE_JOB_TYPE_REQUEST_SUCCESS";
export const UPDATE_JOB_TYPE_REQUEST_FAIL = "UPDATE_JOB_TYPE_REQUEST_FAIL";

//delete job type
export const DELETE_JOB_TYPE = "DELETE_JOB_TYPE";
export const DELETE_JOB_TYPE_SUCCESS = "DELETE_JOB_TYPE_SUCCESS";
export const DELETE_JOB_TYPE_FAIL = "DELETE_JOB_TYPE_FAIL";

//get leave type
export const GET_LEAVE_TYPE = "GET_LEAVE_TYPE";
export const GET_LEAVE_TYPE_SUCCESS = "GET_LEAVE_TYPE_SUCCESS";
export const GET_LEAVE_TYPE_FAIL = "GET_LEAVE_TYPE_FAIL";

//get leave type workflow
export const GET_LEAVE_TYPE_WORKFLOW = "GET_LEAVE_TYPE_WORKFLOW";
export const GET_LEAVE_TYPE_WORKFLOW_SUCCESS =
  "GET_LEAVE_TYPE_WORKFLOW_SUCCESS";
export const GET_LEAVE_TYPE_WORKFLOW_FAIL = "GET_LEAVE_TYPE_WORKFLOW_FAIL";

//get leave history
export const GET_LEAVE_HISTORY_BY_TOKEN = "GET_LEAVE_HISTORY_BY_TOKEN";
export const GET_LEAVE_HISTORY_BY_TOKEN_SUCCESS =
  "GET_LEAVE_HISTORY_BY_TOKEN_SUCCESS";
export const GET_LEAVE_HISTORY_BY_TOKEN_FAIL =
  "GET_LEAVE_HISTORY_BY_TOKEN_FAIL";

//get leave history detail
export const GET_LEAVE_HISTORY_DETAIL_BY_TOKEN =
  "GET_LEAVE_HISTORY_DETAIL_BY_TOKEN";
export const GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_SUCCESS =
  "GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_SUCCESS";
export const GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_FAIL =
  "GET_LEAVE_HISTORY_DETAIL_BY_TOKEN_FAIL";

//get allowance
export const GET_PAYROLL_ALLOWANCE = "GET_PAYROLL_ALLOWANCE";
export const GET_PAYROLL_ALLOWANCE_SUCCESS = "GET_PAYROLL_ALLOWANCE_SUCCESS";
export const GET_PAYROLL_ALLOWANCE_FAIL = "GET_PAYROLL_ALLOWANCE_FAIL";

//get insurance
export const GET_PAYROLL_INSURANCE = "GET_PAYROLL_INSURANCE";
export const GET_PAYROLL_INSURANCE_SUCCESS = "GET_PAYROLL_INSURANCE_SUCCESS";
export const GET_PAYROLL_INSURANCE_FAIL = "GET_PAYROLL_INSURANCE_FAIL";

//get PIT
export const GET_PAYROLL_PIT = "GET_PAYROLL_PIT";
export const GET_PAYROLL_PIT_SUCCESS = "GET_PAYROLL_PIT_SUCCESS";
export const GET_PAYROLL_PIT_FAIL = "GET_PAYROLL_PIT_FAIL";

//get payroll users
export const GET_PAYROLL_USERS = "GET_PAYROLL_USERS";
export const GET_PAYROLL_USERS_SUCCESS = "GET_PAYROLL_USERS_SUCCESS";
export const GET_PAYROLL_USERS_FAIL = "GET_PAYROLL_USERS_FAIL";

//get payroll users
export const EXPORT_PAYROLL_USERS = "EXPORT_PAYROLL_USERS";
export const EXPORT_PAYROLL_USERS_SUCCESS = "EXPORT_PAYROLL_USERS_SUCCESS";
export const EXPORT_PAYROLL_USERS_FAIL = "EXPORT_PAYROLL_USERS_FAIL";

//get payroll user setting
export const GET_PAYROLL_USER_SETTING = "GET_PAYROLL_USER_SETTING";
export const GET_PAYROLL_USER_SETTING_SUCCESS =
  "GET_PAYROLL_USER_SETTING_SUCCESS";
export const GET_PAYROLL_USER_SETTING_FAIL = "GET_PAYROLL_USER_SETTING_FAIL";

//get generate user payroll
export const GENERATE_USER_PAYROLL = "GENERATE_USER_PAYROLL";
export const GENERATE_USER_PAYROLL_SUCCESS = "GENERATE_USER_PAYROLL_SUCCESS";
export const GENERATE_USER_PAYROLL_FAIL = "GENERATE_USER_PAYROLL_FAIL";

//get PIT
export const GET_PAYROLL_CONTRATCS = "GET_PAYROLL_CONTRATCS";
export const GET_PAYROLL_CONTRATCS_SUCCESS = "GET_PAYROLL_CONTRATCS_SUCCESS";
export const GET_PAYROLL_CONTRATCS_FAIL = "GET_PAYROLL_CONTRATCS_FAIL";

//get PIT
export const GET_USER_PAYROLL = "GET_USER_PAYROLL";
export const GET_USER_PAYROLL_SUCCESS = "GET_USER_PAYROLL_SUCCESS";
export const GET_USER_PAYROLL_FAIL = "GET_USER_PAYROLL_FAIL";

//get user report
export const GET_USER_REPORT = "GET_USER_REPORT";
export const GET_USER_REPORT_SUCCESS = "GET_USER_REPORT_SUCCESS";
export const GET_USER_REPORT_FAIL = "GET_USER_REPORT_FAIL";

//get PIT
export const GET_PAYROLL_CONVERSION = "GET_PAYROLL_CONVERSION";
export const GET_PAYROLL_CONVERSION_SUCCESS = "GET_PAYROLL_CONVERSION_SUCCESS";
export const GET_PAYROLL_CONVERSION_FAIL = "GET_PAYROLL_CONVERSION_FAIL";

//get allowance user
export const GET_PAYROLL_ALLOWANCE_USER = "GET_PAYROLL_ALLOWANCE_USER";
export const GET_PAYROLL_ALLOWANCE_USER_SUCCESS =
  "GET_PAYROLL_ALLOWANCE_USER_SUCCESS";
export const GET_PAYROLL_ALLOWANCE_USER_FAIL =
  "GET_PAYROLL_ALLOWANCE_USER_FAIL";

//get overtime
export const GET_SETTING_OVERTIME = "GET_SETTING_OVERTIME";
export const GET_SETTING_OVERTIME_SUCCESS = "GET_SETTING_OVERTIME_SUCCESS";
export const GET_SETTING_OVERTIME_FAIL = "GET_SETTING_OVERTIME_FAIL";
//get allowance user
export const GET_PAYROLL_COMMISION_USER = "GET_PAYROLL_COMMISION_USER";
export const GET_PAYROLL_COMMISION_USER_SUCCESS =
  "GET_PAYROLL_COMMISION_USER_SUCCESS";
export const GET_PAYROLL_COMMISION_USER_FAIL =
  "GET_PAYROLL_COMMISION_USER_FAIL";

//get commission setting
export const GET_PAYROLL_COMMISSION_SETTING = "GET_PAYROLL_COMMISSION_SETTING";
export const GET_PAYROLL_COMMISSION_SETTING_SUCCESS =
  "GET_PAYROLL_COMMISSION_SETTING_SUCCESS";
export const GET_PAYROLL_COMMISSION_SETTING_FAIL =
  "GET_PAYROLL_COMMISSION_SETTING_FAIL";

//get overtime user
export const GET_PAYROLL_OVERTIME_USER = "GET_PAYROLL_OVERTIME_USER";
export const GET_PAYROLL_OVERTIME_USER_SUCCESS =
  "GET_PAYROLL_OVERTIME_USER_SUCCESS";
export const GET_PAYROLL_OVERTIME_USER_FAIL = "GET_PAYROLL_OVERTIME_USER_FAIL";
//get SETTING QRCODE
export const GET_SETTING_QRCODE = "GET_SETTING_QRCODE";
export const GET_SETTING_QRCODE_SUCCESS = "GET_SETTING_QRCODE_SUCCESS";
export const GET_SETTING_QRCODE_FAIL = "GET_SETTING_QRCODE_FAIL";
export const GET_SETTING_QRCODE_ROOM = "GET_SETTING_QRCODE_ROOM";
export const GET_SETTING_QRCODE_ROOM_SUCCESS =
  "GET_SETTING_QRCODE_ROOM_SUCCESS";
export const GET_SETTING_QRCODE_ROOM_FAIL = "GET_SETTING_QRCODE_ROOM_FAIL";
export const UPDATE_SETTING_QRCODE_ROOM = "UPDATE_SETTING_QRCODE_ROOM";
export const UPDATE_SETTING_QRCODE_ROOM_FAIL =
  "UPDATE_SETTING_QRCODE_ROOM_FAIL";

// login with KEYCLOAK
export const LOGIN_WITH_KEYCLOAK = "LOGIN_WITH_KEYCLOAK";
export const LOGIN_WITH_KEYCLOAK_SUCCESS = "LOGIN_WITH_KEYCLOAK_SUCCESS";
export const LOGIN_WITH_KEYCLOAK_FAIL = "LOGIN_WITH_KEYCLOAK_FAIL";

// daily report list
export const DAILY_REPORT_LIST = "DAILY_REPORT_LIST";
export const DAILY_REPORT_LIST_SUCCESS = "DAILY_REPORT_LIST_SUCCESS";
export const DAILY_REPORT_LIST_FAIL = "DAILY_REPORT_LIST_FAIL";

// daily report bt user
export const DAILY_REPORT_SETTING_BY_USER = "DAILY_REPORT_SETTING_BY_USER";
export const DAILY_REPORT_SETTING_BY_USER_SUCCESS =
  "DAILY_REPORT_SETTING_BY_USER_SUCCESS";
export const DAILY_REPORT_SETTING_BY_USER_FAIL =
  "DAILY_REPORT_SETTING_BY_USER_FAIL";

// create daily report
export const CREATE_DAILY_REPORT = "CREATE_DAILY_REPORT";
export const CREATE_DAILY_REPORT_SUCCESS = "CREATE_DAILY_REPORT_SUCCESS";
export const CREATE_DAILY_REPORT_FAIL = "CREATE_DAILY_REPORT_FAIL";

// get daily report template
export const DAILY_REPORT_TEMPLATE = "DAILY_REPORT_TEMPLATE";
export const DAILY_REPORT_TEMPLATE_SUCCESS = "DAILY_REPORT_TEMPLATE_SUCCESS";
export const DAILY_REPORT_TEMPLATE_FAIL = "DAILY_REPORT_TEMPLATE_FAIL";

// get all daily report template
export const ALL_DAILY_REPORT_LIST = "ALL_DAILY_REPORT_LIST";
export const ALL_DAILY_REPORT_LIST_SUCCESS = "ALL_DAILY_REPORT_LIST_SUCCESS";
export const ALL_DAILY_REPORT_LIST_FAIL = "ALL_DAILY_REPORT_LIST_FAIL";
export const SHOULD_FETCH_DATA_DAILY_TEMPLATE =
  "SHOULD_FETCH_DATA_DAILY_TEMPLATE";

// create daily report template
export const CREATE_DAILY_REPORT_TEMPLATE = "CREATE_DAILY_REPORT_TEMPLATE";
export const CREATE_DAILY_REPORT_TEMPLATE_SUCCESS =
  "CREATE_DAILY_REPORT_TEMPLATE_SUCCESS";
export const CREATE_DAILY_REPORT_TEMPLATE_FAIL =
  "CREATE_DAILY_REPORT_TEMPLATE_FAIL";

// create daily report template
export const CREATE_DAILY_REPORT_FOR_USER = "CREATE_DAILY_REPORT_FOR_USER";
export const CREATE_DAILY_REPORT_FOR_USER_SUCCESS =
  "CREATE_DAILY_REPORT_FOR_USER_SUCCESS";
export const CREATE_DAILY_REPORT_FOR_USER_FAIL =
  "CREATE_DAILY_REPORT_FOR_USER_FAIL";

// get daily report today
export const GET_DAILY_REPORT_TODAY = "GET_DAILY_REPORT_TODAY";
export const GET_DAILY_REPORT_TODAY_SUCCESS = "GET_DAILY_REPORT_TODAY_SUCCESS";
export const GET_DAILY_REPORT_TODAY_FAIL = "GET_DAILY_REPORT_TODAY_FAIL";

// ==============================================================================
//get all branches
export const GET_ALL_BRANCH_REQUEST = "GET_ALL_BRANCH_REQUEST";
export const GET_ALL_BRANCH_SUCCESS = "GET_ALL_BRANCH_SUCCESS";
export const GET_ALL_BRANCH_FAIL = "GET_ALL_BRANCH_FAIL";

// get all teams
export const GET_ALL_TEAM_REQUEST = "GET_ALL_TEAM_REQUEST";
export const GET_ALL_TEAM_SUCCESS = "GET_ALL_TEAM_SUCCESS";
export const GET_ALL_TEAM_FAIL = "GET_ALL_TEAM_FAIL";

// get all teams
export const GET_ALL_USER_REQUEST = "GET_ALL_USER_REQUEST";
export const GET_ALL_USER_SUCCESS = "GET_ALL_USER_SUCCESS";
export const GET_ALL_USER_FAIL = "GET_ALL_USER_FAIL";

// clear filter
export const CLEAR_FILTER_WORKED_SHIFT = "CLEAR_FILTER_WORKED_SHIFT";
